export const loggerServerUrl = "https://seq.alif.tj/";
